import { render } from "./FormItem.vue?vue&type=template&id=628a9a34&scoped=true"
const script = {}

import "./FormItem.vue?vue&type=style&index=0&id=628a9a34&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-628a9a34"

export default script